__turbopack_context__.v({
  "logIn": "dFsGca_logIn",
  "menu": "dFsGca_menu",
});
